<template>
  <card-container-layout :borderColor="borderColor" :addShadow="true">
    <div class="report__agent-card-container" :style="styles.container">
      <img :src="agentImageUrl" class="report__agent-avatar" crossorigin="*" />
      <div :style="styles.details">
        <default-card-title-component
          :text="agentName"
          size-variation="medium"
        ></default-card-title-component>
        <p class="report__agent-details" v-if="agentTitle">{{ agentTitle }}</p>
        <p class="report__agent-details" v-if="agentNumber">{{ agentNumber }}</p>
        <p class="report__agent-details no-underline" v-if="agentEmail">
          <a :href="`mailto:${agentEmail}`" class="report__agent-email no-underline">{{
            agentEmail
          }}</a>
        </p>
      </div>
    </div>
  </card-container-layout>
</template>
<script>
import CardContainerLayout from '../Common/CardContainerLayout.vue';
import DefaultCardTitleComponent from '../Common/DefaultCardTitleComponent.vue';
import { DEFAULT_BRAND_SECONDARY_COLOR } from '../constants';
export default {
  components: {
    CardContainerLayout,
    DefaultCardTitleComponent,
  },
  props: {
    layout: String,
    agentName: String,
    agentTitle: String,
    agentNumber: String,
    agentEmail: String,
    agentImageUrl: String,
  },
  inject: ['getBrandSecondaryBackground'],
  computed: {
    borderColor() {
      const primary = this.getBrandSecondaryBackground();
      return primary ? primary : DEFAULT_BRAND_SECONDARY_COLOR;
    },
    styles() {
      const details = {
        marginLeft: this.layout === 'horizontal' ? '16px' : '0px',
        marginTop: this.layout === 'vertical' ? '16px' : '0px',
      };

      const container = {
        flexDirection: this.layout === 'horizontal' ? 'row' : 'column',
      };

      return {
        details,
        container: {
          display: 'flex',
          ...container,
        },
      };
    },
  },
};
</script>

<style scoped>
.report__agent-avatar {
  width: 100px;
  height: 100px;
  object-fit: cover;
  border-radius: 999px;
}
.report__agent-details {
  margin-bottom: 0;
  color: black;
  font-family: 'DM Sans';
}
.report__agent-email {
  color: black;
}
</style>
